import { FullBooking } from '@alluradirect/react';
import {
  TimelineItem,
  TimelineItemSpacer,
  TimelineWrapper,
} from 'scenes/dashboard/views/Reservation/components/styles';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import SwapHorizontalCircleIcon from '@mui/icons-material/SwapHorizontalCircle';
import { Typography } from '@mui/material';

interface Props {
  timeline: FullBooking['TIMELINE'];
}

export const ReservationTimeline = ({ timeline }: Props) => {
  return (
    <>
      {timeline.map(item => {
        return (
          <TimelineWrapper key={`${item.DATE}${item.TITLE}`}>
            <TimelineItem className={item.IS_COMPLETED ? 'enabled' : 'disabled'}>
              {item.IS_COMPLETED ? (
                <CheckCircleIcon className="icon enabled" />
              ) : (
                <SwapHorizontalCircleIcon className="icon disabled" />
              )}
              <div>
                <Typography variant="body1">
                  <strong>{item.TITLE}</strong>
                </Typography>
                <Typography variant="caption">{item.DATE}</Typography>
              </div>
            </TimelineItem>
            <TimelineItemSpacer className={item.IS_COMPLETED ? 'enabled' : 'disabled'} />
          </TimelineWrapper>
        );
      })}
    </>
  );
};
